import { useEffect } from "react";
import { useAppThemeOptional } from "../../contexts/ThemeContext";
import { useTenantTheme } from "../../hooks/useTenantTheme";

/**
 * Invisible component that fetches tenant theme overrides and injects them
 * into AppThemeProvider's runtime state.
 *
 * Must be rendered inside QueryProvider + AuthProvider so that:
 * - React Query is available for the fetch
 * - The fetch only fires when the user is authenticated
 *
 * AppThemeProvider renders children immediately (no blocking) — overrides
 * are applied after the API responds, within one render cycle.
 */
export function TenantThemeLoader() {
  const { overrides } = useTenantTheme();
  const themeContext = useAppThemeOptional();

  useEffect(() => {
    if (!themeContext) return;
    themeContext.setTenantOverrides(overrides);
  }, [overrides, themeContext]);

  return null;
}
